import { isLiveMallClub } from '@/constants/systemType'
import { CSSProperties } from 'react'
import ShopButton from '../Button'
import LiveMallClubButton, { TButtonProps } from '../livemallclub/Button'
import { omit } from 'lodash-es'

export type AdaptiveButtonTheme = TButtonProps['theme']

type AdaptiveButtonProps = {
  children: React.ReactNode
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  size?: TButtonProps['size']
  disabled?: boolean
  theme?: AdaptiveButtonTheme
  className?: string
  isOutline?: boolean
  style?: CSSProperties
  throttleDuration?: number
}

const defaultLiveMallClubButtonStyle: CSSProperties = {
  minWidth: 0,
}

const AdaptiveButton = (props: AdaptiveButtonProps) => {
  if (isLiveMallClub) {
    return <LiveMallClubButton styles={props.style ?? defaultLiveMallClubButtonStyle} {...omit(props, ['isOutline', 'throttleDuration'])} />
  }

  return <ShopButton {...props}>{props.children as string | object}</ShopButton>
}

export default AdaptiveButton
